import React from 'react';
import {ScrollView, Text} from 'react-native';
import {storiesOf} from '@storybook/react-native';

import Button from '/component/base/Button';
import {
  Code,
  FlexView,
  Heading,
  Spacer,
  Spacing,
} from '/component/base/Storybook';
import KeyboardAvoidingView from '/component/layout/KeyboardAvoidingView';
import {createPopoverProvider} from '/provider/PopoverProvider';

import Dummy from './Dummy';
import DummyWithInput from './DummyWithInput';
import DummyWithScroll from './DummyWithScroll';

const StoryPopoverProvider = createPopoverProvider({isStorybook: true});

storiesOf('base', module).add('Popover', () => (
  // @ts-expect-error TS(2322): Type '{ children: Element; isStorybook: boolean; }... Remove this comment to see the full error message
  <KeyboardAvoidingView isStorybook={true}>
    <StoryPopoverProvider.Provider>
      <StoryPopoverProvider.Consumer>
        {({popoverShow}) => (
          <ScrollView>
            <Spacing size={20}>
              <FlexView>
                <Heading level={1}>Popover</Heading>
                <Spacer size={16} />
                <Text>
                  The <Code>Popover</Code> component is used to render content
                  shown via a sheet that slides into view from the bottom of the
                  screen.
                </Text>
                <Spacer size={16} />
                <Button onPress={() => popoverShow(Dummy, {message: 'heyo!'})}>
                  Show Popover
                </Button>
                <Spacer size={16} />
                <Heading level={2}>Popover Content Scrolling</Heading>
                <Spacer size={16} />
                <Text>
                  Due to the intricacies of gesture handling code inside{' '}
                  <Code>PopoverProvider</Code>, in order for a popover's content
                  to scroll internally, components in additional to{' '}
                  <Code>ScrollView</Code> are required:
                </Text>
                <Spacer size={6} />
                <Code>{'<Popover>'}</Code>
                <Code>{'  <Text>This part is not scrollable</Text>'}</Code>
                <Code>{'  <View style={{height: 150}}>'}</Code>
                <Code>{'    <ScrollView>'}</Code>
                <Code>{'      <TouchableWithoutFeedback>'}</Code>
                <Code>{'        <View>'}</Code>
                <Code>{'          <Text>Scrollable content:</Text>'}</Code>
                <Code>{'          <Text>has to be wrapped in:</Text>'}</Code>
                <Code>
                  {
                    '          <Text>* A fixed height container containing</Text>'
                  }
                </Code>
                <Code>{'          <Text>* ScrollView containing</Text>'}</Code>
                <Code>
                  {
                    '          <Text>* TouchableWithoutFeedback containing</Text>'
                  }
                </Code>
                <Code>
                  {'          <Text>* A singular child component</Text>'}
                </Code>
                <Code>{'          ...'}</Code>
                <Code>{'        </View>'}</Code>
                <Code>{'      </TouchableWithoutFeedback>'}</Code>
                <Code>{'    </ScrollView>'}</Code>
                <Code>{'  </View>'}</Code>
                <Code>{'</Popover>'}</Code>
                <Spacer size={16} />
                <Button onPress={() => popoverShow(DummyWithScroll, {})}>
                  Show Popover
                </Button>
                <Spacer size={16} />
                <Heading level={2}>Popover Content with Input</Heading>
                <Spacer size={16} />
                <Text>
                  The <Code>PopoverProvider</Code> component automatically
                  handles all necessary adjustments to accommodate the presence
                  of the device's on-screen keyboard:
                </Text>
                <Spacer size={16} />
                <Button onPress={() => popoverShow(DummyWithInput, {})}>
                  Show Popover
                </Button>
              </FlexView>
            </Spacing>
          </ScrollView>
        )}
      </StoryPopoverProvider.Consumer>
    </StoryPopoverProvider.Provider>
  </KeyboardAvoidingView>
));
